import ConfirmationDlg from "../../../components/ConfirmationDlg";
import React, { useEffect } from "react";

function ModalNavigation({ openModal, setOpenModal, children }) {
  const [open, setOpen] = React.useState(false);
  const [textValue, setTextValue] = React.useState("");
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
  };
  const submitHandler = async () => {
    setOpenModal(false);
    setOpen(false);
  };
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  const handleChangeValue = (e) => {
    setTextValue(e.target.value);
  };
  return (
    <ConfirmationDlg
      open={open}
      size={"lg"}
      btnSubmitText={"Close"}
      onSubmit={submitHandler}
      onClose={handleClose}
      hideCancelBtn={true}
    >
      {children}
    </ConfirmationDlg>
  );
}

export default ModalNavigation;
